// iki nokta arasında birden fazla çizgi varsa, üst üste binmesini engellemek ve eğimli çizgiler çizgiler çizmek için noktalar oluşturur..
export function createCurvePoint(
  startPoint: [number, number],
  endPoint: [number, number],
  curvature: number,
): [number, number] {
  const midLat = (startPoint[0] + endPoint[0]) / 2;
  const midLng = (startPoint[1] + endPoint[1]) / 2;

  const dx = endPoint[1] - startPoint[1];
  const dy = endPoint[0] - startPoint[0];

  return [midLat + dx * curvature, midLng + dy * curvature];
}

// rastgele renk kodu oluşturur..
export function getRandomColor() {
  const letters = '0123456789ABCDEF';

  let color = '#';

  for (let i = 0; i < 6; i += 1) {
    color += letters[Math.floor(Math.random() * 16)];
  }

  return color;
}
